/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EncuestaDto } from '../../models/encuesta-dto';

export interface DoctorEncuestasControllerObtenerDetallesEncuesta$Params {

/**
 * UUID de la encuesta a obtener detalles
 */
  uuidEncuesta: string;
}

export function doctorEncuestasControllerObtenerDetallesEncuesta(http: HttpClient, rootUrl: string, params: DoctorEncuestasControllerObtenerDetallesEncuesta$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EncuestaDto>>> {
  const rb = new RequestBuilder(rootUrl, doctorEncuestasControllerObtenerDetallesEncuesta.PATH, 'get');
  if (params) {
    rb.path('uuidEncuesta', params.uuidEncuesta, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<EncuestaDto>>;
    })
  );
}

doctorEncuestasControllerObtenerDetallesEncuesta.PATH = '/api/doctor-encuestas/detalle-encuesta/{uuidEncuesta}';
